import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive('sanitize', {
    mounted(el, binding) {
      el.innerHTML = sanitizeHTML(binding.value)
    },
    updated(el, binding) {
      el.innerHTML = sanitizeHTML(binding.value)
    }
  })
})
